import styled from "styled-components";
import PropTypes from "prop-types";

export const Fieldset = styled.fieldset`
    padding: 0.45rem 0.8875rem 0.45rem 0.9375rem;
    border: ${({ inputFocused }) =>
        inputFocused ? "solid 3px RGBA(62,169,245,0.4)" : "solid 3px #f2f2f2"};
`;

Fieldset.propTypes = {
    inputFocused: PropTypes.bool
};
